<template>
  <div>
    <b-alert :show="error && error.length ? true : false" variant="danger">
      <div v-if="Array.isArray(error)">
        <div
          class="d-flex flex-column my-1"
          v-for="(error_text, index) in error"
          :key="index"
        >
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <div
      class="trip-title mb-3 mt-3"
      id="edit-trip-form-label-from-reservation"
      v-if="tripID && payload?.reservation?.id"
    >
      {{
        $t("journey-reservation-id", {
          id: tripID,
          reservationId: payload.reservation.id,
        })
      }}
    </div>
    <div
      class="trip-title mb-3 mt-3"
      id="edit-trip-form-label-from-reservation"
      v-else-if="tripID && payload?.contract?.id"
    >
      {{
        $t("journey-contract-id", {
          id: tripID,
          contractId: payload.contract.id,
        })
      }}
    </div>
    <div class="block mb-3">
      <div v-if="labelText" class="title mb-3">
         {{ labelText }}
      </div>
      <div class="row" v-if="!$store.getters['enums/is_not_permitted']('editTripLocationByOperator')">
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-input
            id="edit-trip-form-pick-up-location"
            name="pick up location"
            rules="required"
            :is_required="true"
            label="pick-up-location"
            placeholder="add-location"
            cus_style="padding:10px 10px 10px 30px;cursor: pointer;"
            :value="payload?.start?.name"
            @click="toggleLocationPicker('Set pickup location', 'start')"
            :disabled="loading"
            readOnly
          >
            <template v-slot:attachment>
              <div class="location-prefix">
                <img
                  v-if="payload?.start?.name"
                  src="@/assets/images/icons/placeholder-location.svg"
                  alt="placeholder-location"
                />
                <img
                  v-else
                  src="@/assets/images/icons/placeholder-add.svg"
                  alt="placeholder-add"
                />
              </div>
            </template>
          </base-input>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-input
            id="edit-trip-form-drop-off-location"
            label="drop-off-location-optional"
            placeholder="add-location"
            cus_style="padding:10px 10px 10px 30px;cursor: pointer;"
            @click="toggleLocationPicker('Set Dropoff location', 'end')"
            :value="payload?.end?.name"
            :disabled="loading || !payload.start"
            readOnly
          >
            <template v-slot:attachment>
              <div class="location-prefix">
                <img
                  v-if="payload?.end?.name"
                  src="@/assets/images/icons/placeholder-location.svg"
                  alt="placeholder-location"
                />
                <img
                  v-else
                  src="@/assets/images/icons/placeholder-add.svg"
                  alt="placeholder-add"
                />
              </div>
            </template>
          </base-input>
        </div>
      </div>

      <div class="row"  v-if="!this.$store.getters['enums/is_not_permitted']('editTripDateAndTimeByOperator')">
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-date-time-picker
            id="edit-trip-from-date"
            name="from date"
            rules="required"
            label="from-date"
            :is_required="true"
            :timePicker="true"
            date_field="from_date"
            time_field="from_time"
            :value="payload"
            :minDate="new Date()"
            @change-value="
              (date_value, date_field, time_value, time_field) => {
                setValue(date_value, date_field);
                setValue(time_value, time_field);
              }
            "
            :disabled="loading || payload?.reservation?.type === 'Recurrence'"
            :helper_text="
              !validFromDate
                ? $t('invalid-value-of-from-date')
                : !validFromTime
                ? $t('invalid-value-time')
                : ''
            "
            :is_invalid="!validFromDate || !validFromTime"
            helper_text_style="color:var(--color-47);"
          ></base-date-time-picker>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-date-time-picker
            id="edit-trip-to-date"
            name="to date"
            rules="required"
            label="to-date"
            :is_required="true"
            :timePicker="true"
            date_field="to_date"
            time_field="to_time"
            :value="payload"
            :minDate="new Date(payload.from_date)"
            @change-value="
              (date_value, date_field, time_value, time_field) => {
                setValue(date_value, date_field);
                setValue(time_value, time_field);
              }
            "
            :disabled="
              loading ||
              !payload.from_date ||
              payload?.reservation?.type === 'Recurrence'
            "
            :helper_text="
              !validToDate
                ? $t('invalid-value-of-to-date')
                : !validToTime
                ? $t('invalid-value-time')
                : ''
            "
            :is_invalid="!validToDate || !validToTime"
            helper_text_style="color:var(--color-47);"
          ></base-date-time-picker>
        </div>
      </div>
      <div class="col-lg-12 col-md-9 col-sm-12" v-if="!$store.getters['enums/is_not_permitted']('editTripLocationByOperator')">
          <base-select
            id="edit-trip-form-branch"
            name="branch"
            rules="required"
            label="branch"
            :is_required="true"
            :options="$store.getters['enums/branch_enums']"
            field="branch"
            :value="payload.branch"
            @change-value="setValue"
            :disabled="loading || disabledBranch"
          />
          <div v-if="disabledBranch" class="label mb-3">
            <span class="error">{{ $t("edit-branch-message-err") }}</span>
          </div>
        </div>
    </div>
    <location-picker
      :show_picker="show_picker"
      :title="location_title"
      :field="location_field"
      :payload="payload"
      @toggleLocationPicker="toggleLocationPicker"
      @setMarker="setMarker"
    />
  </div>
</template>

<script>
import LocationPicker from "./LocationPicker.vue";
import branchService from "@/services/branch.service";

export default {
  name: "edit-trip",
  components: { LocationPicker },
  props: [
    "payload",
    "loading",
    "validFromDate",
    "validToDate",
    "validFromTime",
    "validToTime",
    "tripID",
    "disabledBranch"
  ],
  data() {
    return {
      show_picker: false,
      location_title: "",
      location_field: "",
      error: null,
    };
  },
  methods: {
    setMarker(location, name) {
      this["payload"][this.location_field] = {
        location,
        name,
      };
    },
    toggleLocationPicker(title, field) {
      this.location_title = title;
      this.location_field = field;
      this.show_picker = !this.show_picker;
      if (this.show_picker) this.$bvModal.show("location-picker-modal");
      else this.$bvModal.hide("location-picker-modal");
    },
    setValue(val, field) {
      this["payload"][field] = val;
    },
    checkIsPickupInBranch(service) {
      let obj = {
        branchID: this.payload?.reservation?.branch?._id,
        pickupLocation: service,
      };
      branchService.post(obj, "is-pickup-point-exists-in-branch-zone")
        .then(({ isExists }) => {
          if (!isExists) {
            this.error = this.$t("pickup-location-not-in-branch");
            this.payload.error_location = true;
          } else {
            this.error = null;
            this.payload.error_location = null;
          }
        });
    },
  },
  computed: {
    labelText() {
      const isLocationPermitted = !this.$store.getters['enums/is_not_permitted']('editTripLocationByOperator');
      const isDatePermitted = !this.$store.getters['enums/is_not_permitted']('editTripDateAndTimeByOperator');

      if (isLocationPermitted && isDatePermitted) {
        return this.$t("location-and-dates");
      } else if (isLocationPermitted) {
        return this.$t("location");
      } else if (isDatePermitted) {
        return this.$t("dates");
      }
    }
  },
  watch: {
    "payload.start": {
      deep: "true",
      handler(val) {
        if (this.payload?.reservation)
          this.checkIsPickupInBranch(val);
      },
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 12px 16px var(--color-38);
  border-radius: 4px;
  padding: 1rem 2rem;

  .title {
    font-weight: 700;
    font-size: 16px;
    color: var(--color-09);
    margin-bottom: 1.5rem;
  }

  .label {
    font-size: 14px;
    color: var(--color-02);
  }
  .value {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-17);
  }
  .error {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-47);
  }
}
.trip-title {
  font-weight: 700;
  font-size: 16px;
  color: var(--color-17);
}

.location-prefix {
  position: absolute;
  top: 33px;
  left: 10px;
}
</style>
